import getOr from "lodash/fp/getOr";

export class Category {
  constructor(id, name, created_at, updated_at) {
    this.id = id;
    this.name = name;
    this.created_at = created_at
    this.updated_at = updated_at;
    this.link = `<a href="/blogs?category=${this.id}">${this.name}</a>`;
  }
  static fromApiObject(input) {
    if (typeof (input) === "object" && input !== null) {
      const id = getOr("", "id")(input);
      const name = getOr("", "name")(input);
      const created_at = getOr("", "created_at")(input);
      const updated_at = getOr("", "updated_at")(input);
      return new Category(id, name, created_at, updated_at);
    }
    return new Category();
  }
  static fromApiArray(input) {
    if (Array.isArray(input)) {
      return input.map(item => Category.fromApiObject(item));
    }
    if (typeof (input) === "object" && input !== null) {
      return [Category.fromApiObject(input)];
    }
    return [];
  }
}